/**
 * Progressively enhances a search form (native `minlength="2"` already
 * blocks a too-short submit with the browser's own validation UI): keeps
 * the submit button visually disabled while the query is under 2 characters
 * so the disabled state is obvious before the shopper even tries to submit.
 *
 * DOM contract: `[data-search-form]` contains `[data-search-input]` and
 * `[data-search-submit]`.
 */
document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-search-input]')) return;

  const form = event.target.closest('[data-search-form]');
  const submit = form?.querySelector('[data-search-submit]');
  if (submit) submit.disabled = event.target.value.trim().length < 2;
});
